/**
 * @generated SignedSource<<1331a65f8d8f813f54fd0d91515abbc7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ForgotPassword_isAllowed$data = {
  readonly " $fragmentSpreads": FragmentRefs<"user_isGuest">;
  readonly " $fragmentType": "ForgotPassword_isAllowed";
};
export type ForgotPassword_isAllowed$key = {
  readonly " $data"?: ForgotPassword_isAllowed$data;
  readonly " $fragmentSpreads": FragmentRefs<"ForgotPassword_isAllowed">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "ForgotPassword_isAllowed"
};

(node as any).hash = "ccdbc88baf60ebe4b506b00a62ec6f6c";

export default node;
